<template>
    <button class="kleptos-dock-slot"><i class="fa fa-lock"></i></button>
</template>

<script>
    export default {
        data () {
            return {

            }
        }
    }
</script>

<style lang="scss" scoped>
    .kleptos-dock-slot {
        background: rgba(black, 0.38);
        border: 0;
        width: rem-calc(52); //52px;
        height: rem-calc(52); //52px;
        color: darken(#999, 20%);
        margin: rem-calc(0 6); //0 6px;
        border-radius: rem-calc(5);
    }
</style>